import get from 'lodash/get';
import {fork, put, take, call} from 'redux-saga/effects';
import {FormikErrors} from 'formik';

import {http} from 'services/http';
import {setToken, setRefreshToken} from 'services/localStorage';

import {
    FORMS_LIST_PAUSE_ON,
    formsListPauseOn,
    FORMS_LIST_PAUSE_OFF,
    formsListPauseOff,
    FORM_PAUSE_ON,
    formPauseOn,
    FORM_PAUSE_OFF,
    formPauseOff,
} from 'appRedux/actions/forms';

import {
    FormUpdateResponseTypes,
    FormsTableListResponseType,
    FormsListPauseRequestType,
    FormsListPauseOffRequestType,
    FormPauseRequestType,
    FormPauseOffRequestType,
} from 'appRedux/actions/forms/types';

import {getRouteWithParameters} from 'helpers/sagasHelper';

import {ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS} from 'config/index';

function* watchFormPauseOn() {
    while (true) {
        const {
            payload: {id, callback, showAlert, ...values},
        }: IActionType<FormPauseRequestType> = yield take(FORM_PAUSE_ON.REQUEST);
        try {
            const data: FormUpdateResponseTypes = yield call(http, `form/${id}/pause`, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(formPauseOn.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(formPauseOn.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(formPauseOn.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchFormPauseOff() {
    while (true) {
        const {
            payload: {id, callback, showAlert},
        }: IActionType<FormPauseOffRequestType> = yield take(FORM_PAUSE_OFF.REQUEST);
        try {
            const data: FormUpdateResponseTypes = yield call(http, `form/${id}/unpause`, {
                method: 'POST',
            });
            if (data.success) {
                yield put(formPauseOff.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(formPauseOff.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(formPauseOff.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchFormsListPauseOn() {
    while (true) {
        const {
            payload: {id, callback, showAlert, workflow, labels, page, perPage, search, sortBy, sortType, ...values},
        }: IActionType<FormsListPauseRequestType> = yield take(FORMS_LIST_PAUSE_ON.REQUEST);
        try {
            const route = getRouteWithParameters(`form/list/${id}/pause`, {
                workflow,
                labels,
                page,
                perPage,
                search,
                sortBy,
                sortType,
            });
            const data: FormsTableListResponseType = yield call(http, route, {
                method: 'POST',
                body: JSON.stringify(values),
            });
            if (data.success) {
                yield put(formsListPauseOn.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(formsListPauseOn.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(formsListPauseOn.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

function* watchFormsListPauseOff() {
    while (true) {
        const {
            payload: {id, callback, workflow, labels, page, perPage, search, sortBy, sortType, showAlert},
        }: IActionType<FormsListPauseOffRequestType> = yield take(FORMS_LIST_PAUSE_OFF.REQUEST);
        try {
            const route = getRouteWithParameters(`form/list/${id}/unpause`, {
                workflow,
                labels,
                page,
                perPage,
                search,
                sortBy,
                sortType,
            });
            const data: FormsTableListResponseType = yield call(http, route, {
                method: 'POST',
            });
            if (data.success) {
                yield put(formsListPauseOff.success(data.results));
                callback && callback();
                showAlert && showAlert(ALERT_TYPE_SUCCESS);
            } else {
                yield put(formsListPauseOff.error({message: 'messages.error.somethingWentWrong'}));
                showAlert && showAlert(ALERT_TYPE_ERROR);
            }
        } catch (e) {
            yield put(formsListPauseOff.error({message: String(e)}));
            showAlert && showAlert(ALERT_TYPE_ERROR);
        }
    }
}

export default [
    fork(watchFormPauseOn),
    fork(watchFormPauseOff),
    fork(watchFormsListPauseOn),
    fork(watchFormsListPauseOff),
];
